"use strict";

var _slicedToArray = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var types_1 = require("@babel/types");

var typedraft_1 = require("typedraft");

var draft_dsl_match_1 = require("draft-dsl-match");

var ts_pattern_1 = require("ts-pattern");

exports.__ = ts_pattern_1.__;
exports.MatchDSL = ts_pattern_1.match;
exports.when = ts_pattern_1.when;
exports.not = ts_pattern_1.not;
exports.use = ts_pattern_1.select;
exports.String = draft_dsl_match_1.__.string;
exports.Number = draft_dsl_match_1.__.number;
exports.Boolean = draft_dsl_match_1.__.boolean;

var PatternMatch =
/*#__PURE__*/
function () {
  function PatternMatch(config) {
    _classCallCheck(this, PatternMatch);

    var _a;

    this.m_Factory = (_a = config === null || config === void 0 ? void 0 : config.factory) !== null && _a !== void 0 ? _a : "MatchDSL";
  }

  _createClass(PatternMatch, [{
    key: "InplaceTranscribe",
    value: function InplaceTranscribe(literal, output_type) {
      var template_elements = literal.node.quasis;
      var template_expressions = literal.node.expressions;

      var _template_expressions = _slicedToArray(template_expressions, 1),
          to_match = _template_expressions[0];

      var root = this.CallChainRoot(to_match, output_type);
      template_elements.forEach(function (each, index) {
        if (each.value.raw.trim() === "->") {
          var arg1 = template_expressions[index - 1];
          var handler = template_expressions[index];

          var _draft_dsl_match_1$Ma = draft_dsl_match_1.MatchDSL(arg1).with({
            type: "CallExpression",
            callee: {
              name: draft_dsl_match_1.not("not")
            }
          }, function () {
            return {
              predicate: WrapAsArrowFunctionExpression(arg1),
              method: types_1.identifier("when")
            };
          }).when(function () {
            return ["BinaryExpression", "LogicalExpression"].includes(arg1.type);
          }, function () {
            return {
              predicate: WrapAsArrowFunctionExpression(arg1),
              method: types_1.identifier("when")
            };
          }).with({
            type: "ArrowFunctionExpression"
          }, function () {
            return {
              predicate: arg1,
              method: types_1.identifier("when")
            };
          }).with(draft_dsl_match_1.__, function () {
            return {
              pattern: arg1,
              method: types_1.identifier("with")
            };
          }).run(),
              predicate = _draft_dsl_match_1$Ma.predicate,
              pattern = _draft_dsl_match_1$Ma.pattern,
              method = _draft_dsl_match_1$Ma.method;

          var _handler = draft_dsl_match_1.MatchDSL(handler).with({
            type: "ArrowFunctionExpression",
            body: {
              extra: {
                parenthesized: true
              }
            }
          }, function () {
            var _handler = WrapAsArrowFunctionExpression(handler.body);

            _handler.params = handler.params;
            return _handler;
          }).with({
            type: "ArrowFunctionExpression"
          }, function () {
            return handler;
          }).with(draft_dsl_match_1.__, function () {
            return WrapAsArrowFunctionExpression(handler);
          }).run();

          root = AppendToCallChain(root, method, [pattern !== null && pattern !== void 0 ? pattern : predicate, _handler]);
        }
      });
      root = AppendToCallChain(root, types_1.identifier("run"), []);
      return root;
    }
  }, {
    key: "CallChainRoot",
    value: function CallChainRoot(to_match, output_type) {
      var root = types_1.callExpression(types_1.identifier(this.m_Factory), [to_match]);

      if (types_1.isTSAsExpression(to_match)) {
        root.typeParameters = types_1.tsTypeParameterInstantiation([to_match.typeAnnotation]);
        root.arguments = [to_match.expression];

        if (output_type) {
          var type = CreateTSTypeFromString(output_type);
          root.typeParameters.params.push(type);
        }
      }

      return root;
    }
  }]);

  return PatternMatch;
}();

exports.PatternMatch = PatternMatch;

var WrapAsArrowFunctionExpression = function WrapAsArrowFunctionExpression(expression) {
  return types_1.arrowFunctionExpression([], types_1.blockStatement([types_1.returnStatement(expression)]));
};

var CreateTSTypeFromString = function CreateTSTypeFromString(type) {
  return typedraft_1.ToAst("type _ = ".concat(type)).typeAnnotation;
};

var AppendToCallChain = function AppendToCallChain(root, method, args) {
  return types_1.callExpression(types_1.memberExpression(root, method), args);
};